// extracted by mini-css-extract-plugin
export var filterIncDec = "_ap-0";
export var leftBorder = "_ap-1";
export var rightBorder = "_ap-2";
export var stringInput = "_ap-3";